import React, { Component } from 'react';

class WindowedMenu extends Component {
	render() {
		return (
			<div className="WindowedMenu">
				<ul>
					<li><a href="h">Home</a></li>
					<li><a href="a">CRM</a></li>
					<li><a href="b">Dispatch</a></li>
					<li className="float_right_all"><a href="c">Log Out</a></li>
				</ul>
			</div>
		);
	}
}
export default WindowedMenu;


// WEBPACK FOOTER //
// ./src/components/windowed/WindowedMenu.js